// Périmètre de poussée : LA définition, partagée par push-signatures (handler) et l'écran Déploiement,
// pour que le nombre affiché sous « Forcer tout » soit exactement ce que le bouton réécrit.
import type { Person } from './types.ts';

/** Boîte poussée par push-signatures : gérée, active et non suspendue dans Google Workspace. */
export const inPushScope = (p: Pick<Person, 'active' | 'managed' | 'google_suspended'>): boolean => p.active && p.managed && !p.google_suspended;
export const PUSH_SCOPE_LABEL = 'gérées, actives, non suspendues';
